import { Routes } from '@angular/router';
import { app_main_routing_menu } from '@shared/app-main-routing-menu';
import { authGuard } from './guards/auth.guard';
import { PageWrapperComponent } from '@shared/components/page-wrapper/page-wrapper.component';

export const routes: Routes = [
  {
    path: app_main_routing_menu.login.path,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    loadComponent: () =>
      import('./pages/authentication/authentication.component').then(
        m => m.AuthenticationComponent,
      ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/authentication/login/login.component').then(
            m => m.LoginComponent,
          ),
      },
    ],
  },
  {
    path: app_main_routing_menu.signin.path,
    loadComponent: () =>
      import('./pages/authentication/signin-callback/signin-callback.component').then(
        m => m.SigninCallbackComponent,
      ),
  },
  {
    path: app_main_routing_menu.activate.path,
    loadComponent: () =>
      import('./pages/authentication/activate/activate.component').then(
        m => m.ActivateComponent,
      ),
  },
  {
    path: app_main_routing_menu.forbidden.path,
    loadComponent: () =>
      import('./pages/authentication/forbidden/forbidden.component').then(
        m => m.ForbiddenComponent,
      ),
  },
  {
    path: app_main_routing_menu.switchTenant.path,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    component: PageWrapperComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@app/pages/tenant-switching/tenant-switching.component').then(
            m => m.TenantSwitchingComponent,
          ),
      },
    ],
  },
  {
    path: app_main_routing_menu.audience_manager.path,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    loadChildren: () =>
      import('@app/pages/audience-manager/audience-manager.module').then(
        m => m.AudienceManagerModule,
      ),
  },
  {
    path: '',
    redirectTo: `${app_main_routing_menu.login.path}`,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: `${app_main_routing_menu.login.path}`,
  },
];
